import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MessageService } from 'src/app/@shared/message/message.service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-stakes',
  templateUrl: './stakes.component.html',
  styleUrls: ['./stakes.component.css']
})
export class StakesComponent implements OnInit {

  public api = api;
  public env = environment;
  public user: any;
  isCollapsed = true;
  public stacks: any;
  public stArr: any[] = [];
  public isLoading: boolean = false;
  public index: any;
  @Output() close = new EventEmitter();

  constructor(public service: WebserviceService,
              private _common: CommonService,
              private _shared: SharedService,
              private _message: MessageService,) {
    this._shared.sharedStake.subscribe(res => {
      this.stacks = (localStorage.getItem(`${this.env.panel}stakes`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}stakes`) as any) : [];
    });
  }

  ngOnInit(): void {
    this.stacks = (localStorage.getItem(`${this.env.panel}stakes`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}stakes`) as any) : [];
    this.stArr = Array(8).fill(0);

  }
  changeStk(i: any) {
    this.index = i;
  }
  setBtnVal() {
    this.isLoading = true;
    let req = this._common.JSON_to_URLEncoded(this.stacks)
    // if(this._common.getToken()) {

    this.service.Post(`${this.env.baseUrl + this.api.stakesUpdate}`, req)
      .subscribe(
        (res) => {
          this.isLoading = false;
          if (res.status == true) {
            this._message.succmessage("Stack Updated successfully");
            localStorage.setItem(`${this.env.panel}stakes`, JSON.stringify(this.stacks))
            this._shared.emitStake('');
            this.close.emit('')
            // this.betData.stakes = this._common.getStakeArray();
          }
          // this.loaderService.hideLoader();
        },
        (err) => {
          // this.loaderService.hideLoader();
          this._message.errmessage(err);
        }
      );
    // } else {
    //   localStorage.removeItem(`${this.env.panel}stakes`);
    //         localStorage.setItem(`${this.env.panel}stakes`, JSON.stringify(this.stacks));
    // }

  }

  ngDoCheck() {
    if (!this.stacks || this.stacks.length == 0) {
      this.stacks = (localStorage.getItem(`${this.env.panel}stakes`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}stakes`) as any) : [];
    }
  }

  // setBtnVal() {
  //   if (this.index != undefined) {
  //     this.isLoading = true;
  //     let rq: any = {};
  //     rq = { ...rq, ...this.stacks }
  //     rq['stake_name_' + (this.index + 1)] = rq['stake_amount_' + (this.index + 1)];
  //     let req = this._common.JSON_to_URLEncoded(rq);

  //     this.service.Post(`${this.env.baseUrl + this.api.stakesUpdate}`, req)
  //       .subscribe(
  //         (res) => {
  //           this.isLoading = false;
  //           if (res.status == true) {
  //             this._message.succmessage("Stack Updated successfully");
  //             localStorage.setItem(`${this.env.panel}stakes`, JSON.stringify(rq));
  //             this.stacks = rq;
  //             // this.betData.stakes = this._common.getStakeArray();
  //           }
  //           // this.loaderService.hideLoader();
  //         },
  //         (err) => {
  //           // this.loaderService.hideLoader();
  //           this._message.errmessage(err);
  //         }
  //       );
  //   }

  // }


}
